export const quickLoanLOV1 = ["DSCR"];

export const detailedLoanLOV1 = [];